import Sticky from 'sticky-js';
import CopyCodeBlock from './modules/CopyCodeBlock';

jQuery(document).ready($ => {
	window.$ = $;
	$('#eckb-article-left-sidebar').attr({ 'data-sticky-container': '' });
	$('.eckb-article-toc').attr({
		'data-margin-top': 120,
		'data-sticky-class': 'dpwe-is-sticky',
		'data-sticky-for': 768
	}).addClass('sticky');


	new Sticky('.eckb-article-toc');
	/*document.addEventListener('scroll', function (event) {
		console.log('scrolling', document.documentElement.scrollTop);

		$('.eckb-article-toc').position({ top: 20 + document.documentElement.scrollTop });
	}, true );*/

	new CopyCodeBlock();
});